var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8 4.5L19.5 6.9C20.2 7.1 20.9 7.4 21.5 7.8L24.3 6.9L26.6 9.2L25.7 12C26.1 12.6 26.4 13.3 26.6 14L29 15.7V18.8L26.6 20.5C26.4 21.2 26.1 21.9 25.7 22.5L26.6 25.3L24.3 27.6L21.5 26.7C20.9 27.1 20.2 27.4 19.5 27.6L17.8 30H14.7L13 27.6C12.3 27.4 11.6 27.1 11 26.7L8.2 27.6L5.9 25.3L6.8 22.5C6.4 21.9 6.1 21.2 5.9 20.5L3.5 18.8V15.7L5.9 14C6.1 13.3 6.4 12.6 6.8 12L5.9 9.2L8.2 6.9L11 7.8C11.6 7.4 12.3 7.1 13 6.9L14.7 4.5H17.8ZM16.25 11.5C13.57 11.5 11.4 13.67 11.4 16.35C11.4 19.03 13.57 21.2 16.25 21.2C18.93 21.2 21.1 19.03 21.1 16.35C21.1 13.67 18.93 11.5 16.25 11.5Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.e2b966339636133d6df89b5b45e6f85a.svg";
export { ForwardRef as ReactComponent };